class StickyHeader extends HTMLElement {
  constructor() {
    super();
    console.log('StickyHeader created');
  }

  connectedCallback() {
    console.log('StickyHeader connected, body classes:', document.body.className);
    this.header = document.querySelector('.shopify-section-header');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let intersectionObserver = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    intersectionObserver.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    // Handle transparent header (only on homepage)
    if (document.body.classList.contains('template-index')) {
      console.log('Transparent header logic running, this element:', this);
      if (scrollTop > 0) {
        console.log('Removing transparent class');
        this.classList.remove('header-wrapper--transparent');
      } else {
        console.log('Adding transparent class');
        this.classList.add('header-wrapper--transparent');
      }
    }

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (this.preventReveal) {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.preventReveal = false;
      }
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
    );
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate-popup');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate-popup',
    );
  }

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal =
      this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

class StaticHeader extends HTMLElement {
  constructor() {
    super();
    console.log('StaticHeader created');
  }

  connectedCallback() {
    console.log('StaticHeader connected, body classes:', document.body.className);
    this.header = document.querySelector('.shopify-section-header');
    this.header.classList.add('shopify-section-header--relative');
    
    // Add scroll handler for transparent header on homepage
    if (document.body.classList.contains('template-index')) {
      this.onScrollHandler = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        console.log('Static header scroll handler running, this element:', this);
        if (scrollTop > 0) {
          console.log('Static: Removing transparent class');
          this.classList.remove('header-wrapper--transparent');
        } else {
          console.log('Static: Adding transparent class');
          this.classList.add('header-wrapper--transparent');
        }
      };
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }
  }

  disconnectedCallback() {
    if (this.onScrollHandler) {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  }
}

customElements.define('static-header', StaticHeader);

// Simple global transparent header handler
document.addEventListener('DOMContentLoaded', function() {
  if (!document.body.classList.contains('template-index')) return;
  
  const headerWrapper = document.querySelector('.header-wrapper--transparent');
  if (!headerWrapper) return;
  
  window.addEventListener('scroll', function() {
    if (window.scrollY > 0) {
      headerWrapper.classList.remove('header-wrapper--transparent');
    } else {
      headerWrapper.classList.add('header-wrapper--transparent');
    }
  });
});
